import { Card, CardContent } from "./ui/card";
import { Button } from "./ui/button";
import { Badge } from "./ui/badge";
import { Checkbox } from "./ui/checkbox";
import { HomeIcon, CalendarDays, Trash2 } from "lucide-react";
import { STATUS_LABEL, hr, hrDateTime, statusBadgeVariant } from "../lib/api";

export function SecretariatRow({ r, type, action, selectable, selected, onToggle, onDelete }) {
  return (
    <Card data-testid={`sec-row-${r.id}`}>
      <CardContent className="p-4 flex items-center justify-between gap-3 flex-wrap">
        <div className="min-w-0 flex items-center gap-3">
          {selectable && (
            <Checkbox
              checked={!!selected[r.id]}
              onCheckedChange={() => onToggle(r.id)}
              data-testid={`select-${r.id}`}
            />
          )}
          {type === "wfh"
            ? <HomeIcon className="w-5 h-5 text-accent shrink-0"/>
            : <CalendarDays className="w-5 h-5 text-primary shrink-0"/>}
          <div>
            <div className="font-medium">{r.employee_name}</div>
            <div className="text-xs text-muted-foreground">
              {type === "wfh"
                ? `${r.employee_katedra} · ${hr(r.start_date)} – ${hr(r.end_date)}${r.broj_mobitela ? ` · ${r.broj_mobitela}` : ""}`
                : `${r.employee_katedra} · Ukupno ${r.total_days} dana`}
            </div>
            <div className="text-[11px] text-muted-foreground mt-0.5 space-x-2">
              <span>Predano: {hrDateTime(r.created_at)}</span>
              {r.manager_decided_at && <span>· Odlučeno: {hrDateTime(r.manager_decided_at)}</span>}
              {r.pdf_generated_at && <span>· Rješenje: {hrDateTime(r.pdf_generated_at)}</span>}
              {r.sent_at && <span>· Poslano: {hrDateTime(r.sent_at)}</span>}
            </div>
            {r.klasa && <div className="text-xs mt-1">KLASA: <code>{r.klasa}</code> · URBROJ: <code>{r.urbroj}</code></div>}
          </div>
        </div>
        <div className="flex items-center gap-2">
          <Badge variant={statusBadgeVariant(r.status)}>{STATUS_LABEL[r.status]}</Badge>
          {action}
          <Button
            size="icon" variant="ghost"
            onClick={() => onDelete({ id: r.id, type, employee_name: r.employee_name, status: r.status })}
            title="Obriši zahtjev"
            className="text-red-600 hover:text-red-700 hover:bg-red-50 h-8 w-8"
            data-testid={`delete-req-${r.id}`}
          >
            <Trash2 className="w-4 h-4"/>
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
